export const MainLoader = ()=> {
        <>Loading...</>
};
